import React, { useState, useRef } from "react";
import { Button, Row, Col, FormControl, Container } from "react-bootstrap";
import { Loader, Icon } from "semantic-ui-react";

import "./manage-course-container.css";
import OraclelearnRosterTableV2 from "../components/oracleLearnRosterTableV2";
import ManageRosterPageHeader from "../components/ManageRosterPageHeader";
import CourseDetailsScrollStrip from "../components/CourseDetailsScrollStrip";

const DEFAULT_SEARCH_HINT = (
  <>
    Scan Badge or Enter ID <br />
    (ID=CDSID, Global ID, or Badge ID)
  </>
);

const ManageCourseContainer = ({
  courseDetails,
  showGearCancelCheckIn = true,
  loadingState: { isLoading, setIsLoading, enrollmentsLoading },
  search: { term, onChangeTerm, onFindLearner, onConfirm },
  pageTitle = "Manage Roster - Scheduled Training",
  searchHint = DEFAULT_SEARCH_HINT,
  rosterContent,
}) => {
  const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);

  const inputElement = useRef();

  return (
    <Container className="bg-white rounded py-3 position-relative manage-course">
      {isLoading && (
        <div className="spinner-overlay-container">
          <div className="spinner-overlay">
            <Loader
              active
              size="big"
              animation="border"
              variant="light"
              inline="centered"
              inverted
            />
            <div className="spinner-text text-light">One Moment...</div>
          </div>
        </div>
      )}

      <ManageRosterPageHeader title={pageTitle} />
      <CourseDetailsScrollStrip courseDetails={courseDetails} />

      <Row>
        <Col xs={3}>
          <section className="manage-course-learner-search mt-4 px-3 py-2">
            <header className="d-flex align-items-center mb-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-person-fill-add"
                viewBox="0 0 16 16"
              >
                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0m-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
              </svg>
              <h3 className="manage-course-learner-title ml-2">Learner Check-In</h3>
            </header>
            <p className="manage-course-learner-desc mb-0">{searchHint}</p>

            <FormControl
              onChange={onChangeTerm}
              ref={inputElement}
              value={term}
              autoFocus
              onFocus={(e) => e.currentTarget.select()}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  onConfirm(event);
                }
              }}
            />
            <div className="d-flex">
              <Button onClick={onConfirm} className="mx-auto mt-3 mb-3 px-4 btn standard-btn bold">
                CONFIRM
              </Button>
            </div>
            <div className="border-top mx-2" />
            <Button
              variant="none"
              className="advanced-toggle-btn"
              onClick={() => setAdvancedSearchOpen(!advancedSearchOpen)}
            >
              <span className="triangle-pointer-container">
                <Icon
                  name="triangle right"
                  size="large"
                  className={`triangle-pointer ${advancedSearchOpen ? "down" : "right"}`}
                />
              </span>
              {` `}
              Advanced
            </Button>
            {advancedSearchOpen && (
              <div className="mt-2 mb-2">
                <Button
                  onClick={(e) => {
                    onFindLearner(e);
                  }}
                  className="d-flex rounded-pill btn standard-btn bold"
                >
                  <Icon name="search" />
                  <div>Find Learner</div>
                </Button>
              </div>
            )}
          </section>
        </Col>

        {rosterContent ?? (
          <OraclelearnRosterTableV2
            setIsLoading={setIsLoading}
            enrollmentsLoading={enrollmentsLoading}
            showGearCancelCheckIn={showGearCancelCheckIn}
          />
        )}
      </Row>
    </Container>
  );
};

export default ManageCourseContainer;
